import { NativeModules } from 'react-native';
import { isAndroid } from '../../constants';
const NavigationMode = NativeModules.NavigationMode;
const getIsGestureNavigation = () => {
    if (isAndroid) {
        return NavigationMode?.isGestureNavigation() ?? true;
    }
    return true;
};
export const isGestureNavigation = getIsGestureNavigation();
